var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"100px"}},[_c('input',{staticClass:"form-control",attrs:{"disabled":_vm.disabled,"inputmode":"numeric"},domProps:{"value":_vm.maskedValue},on:{"input":_vm.onInput,"focus":(event) => event.target.select()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }